import {helper} from '../_helpers/helper';
import _ from 'lodash';

let unmute = helper.ls.get("settings_unmute");

export const defaultSettings = {
    unMute: _.isUndefined(unmute) ? true : unmute
};
